import {useHome} from "./hooks/useHome";
import {withHomeContext} from "./state/homeContext";
import ImageText from "./ImageText";
import Subscription from "./Subscription";
import Testimonials from "./Testimonials";
import ServiceAdvice from "./ServiceAdvice";
import {AppBar, Box, Container, IconButton} from '@mui/material';
import {useAuthentication} from "../auth/hooks/useAuthentication";
import ExpandlessPlaceholder from "../placeholder/ExpandlessPlacehoder";
import {useEffect} from "react";
import {useState} from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import React from "react";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import CircularProgress from "@mui/material/CircularProgress";


const Home = ({setShowNav}) => {
    const {schedule, testimonials, isScheduleLoading} = useHome();
    const {isLoading, isAuthenticated} = useAuthentication();
    const [anchor, setAnchor] = useState(0);
    const [showMoveUpButton, setShowMoveUpButton] = useState(false);
    const [showMoveDownButton, setShowMoveDownButton] = useState(true);
    const {mode} = useDarkMode();
    useEffect(() => {
        if (isScheduleLoading) {
            setShowNav(false);
        } else {
            setShowNav(true);
        }

    }, [isScheduleLoading]);

    const moveUp = () => {
        const tempPosition = anchor - 1;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: "smooth",
            });
            setAnchor(anchor - 1);
        }
        const nextPosition = tempPosition - 1;
        if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveUpButton(false);
            setShowMoveDownButton(true);
        } else {
            setShowMoveUpButton(true);
            setShowMoveDownButton(true);
        }
    };

    const moveDown = () => {
        const tempPosition = anchor + 1;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: "smooth",
            });
            setAnchor(anchor + 1);
        }
        const nextPosition = tempPosition + 1;
        if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveDownButton(false);
            setShowMoveUpButton(true);
        } else {
            setShowMoveDownButton(true);
            setShowMoveUpButton(true);
        }

    };

    const renderSchedule = (list) => {
        const final = [];
        let indexInc = 0;
        list.forEach((child) => {
            const childType = Object.keys(child)[0];
            const childContent = Object.values(child)[0];
            switch(childType) {
                case 'image_text':
                    final.push(<div id={'anchor'+indexInc}><ImageText imageText={childContent} /></div>);
                    indexInc++;
                    break;
                case 'subscription_ordering':
                    final.push(<div id={'anchor'+indexInc}><Subscription/></div>);
                    indexInc++;
                    break;
                case 'service_advice_ordering':
                    final.push(<div id={'anchor'+indexInc}><ServiceAdvice/></div>);
                    indexInc++;
                    break;
                default:
            }
        })
        return (final);
    }

    return !isScheduleLoading ?
            <Box flexGrow={1}>
                {schedule.length > 0 && !isLoading && renderSchedule(schedule)}
                {
                    showMoveUpButton ?
                        <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
                            <IconButton
                                className={'btn-gradient'}
                                sx={{
                                    color: '#FFFFFF',
                                    borderRadius: 0,
                                    borderTopLeftRadius: '10%',
                                    borderBottomLeftRadius: '10%'
                                }}
                                onClick={moveUp}
                            >
                                <ArrowUpwardIcon role="img" aria-label={"Remonter au bloc précédent"}/>
                            </IconButton>
                        </Box> : <div></div>
                }
                {
                    showMoveDownButton ?
                        <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
                            <IconButton
                                className={'btn-gradient'}
                                sx={{
                                    color: '#FFFFFF',
                                    borderRadius: 0,
                                    borderTopLeftRadius: '10%',
                                    borderBottomLeftRadius: '10%'
                                }}
                                onClick={moveDown}
                            >
                                <ArrowDownwardIcon role="img" aria-label={"Descendre au prochain bloc"}/>
                            </IconButton>
                        </Box>: <div></div>
                }
            </Box>:
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '80vh',
                backgroundColor: 'transparent !important'
            }}
        >
            <CircularProgress size={50}/>
        </Box>
}

export default withHomeContext(Home);
